module.exports = __webpack_public_path__ + "static/img/qr_qw_code.b7669ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr_qw_code.png
// module id = Nwvl
// module chunks = 94